import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import { UserId } from 'api/models';
import { BUILD_ID } from 'config/environment';
import { logger } from 'services';
import { isHippaAccount } from 'utils/is-hippa-account';
import { isLocalhost } from 'utils/is-localhost';
import {
  isOrbitsEnvironment,
  isShardTestEnvironment,
} from 'utils/is-nitro-env';

interface LogRocketUserTraits {
  [propName: string]: string | number | boolean;
}

export interface UserTraits extends LogRocketUserTraits {
  name: string;
  email: string;
  accountId: number;
  emailId: string;
  fullName: string;
  userId: number;
}

export const setupLogRocketIdentify = (
  traits: UserTraits,
  id?: UserId,
): void => {
  /**
   * TODO: @Shajansheriff check if we need to do this
   * we need to end sessions when we logout etc
   * // LogRocket.startNewSession();
   */
  if (isShardTestEnvironment()) {
    logger.log('LogRocket is disabled on localhost and shard test page');
  }
  if (id == null) {
    LogRocket.identify(traits);
  } else {
    LogRocket.identify(id[1].toString(), traits);
  }
  if (!isShardTestEnvironment()) {
    logger.debug('identifying user', { id, traits });
  }
};

export const initLogRocket = (): void => {
  // disable LogRocket in localhost and login page
  if (
    isLocalhost() ||
    window.location.pathname.includes('/login') ||
    isOrbitsEnvironment() ||
    isShardTestEnvironment()
  ) {
    logger.log('LogRocket is disabled on localhost and login page');

    return;
  }

  if (isHippaAccount()) {
    logger.log('LogRocket is disabled for hippa compliant accounts');

    return;
  }

  setupLogRocketReact(LogRocket);

  LogRocket.init('oieheh/rocketlane-prod', {
    release: BUILD_ID,
    network: {
      requestSanitizer: (request) => {
        if (request.url.toLowerCase().indexOf('authn') !== -1) {
          request.body = undefined;
        }
        request.headers['api-key'] = undefined;

        return request;
      },
    },
  });
};
